import { ComponentPropsWithoutRef, forwardRef } from "react";
import {
  ChevronOrientation,
  Icon,
  getOffsetAndRotation,
} from "./ChevronIcon.Parts";

export const ChevronIcon = forwardRef<
  SVGSVGElement,
  ComponentPropsWithoutRef<"svg"> & {
    orientation?: ChevronOrientation | number;
  }
>(({ orientation = "down", ...props }, ref) => {
  const { offset, rotation } = getOffsetAndRotation(orientation);

  return (
    <Icon
      height="8"
      viewBox="0 0 12 8"
      xmlns="http://www.w3.org/2000/svg"
      $rotation={rotation}
      $offset={offset}
      ref={ref}
      {...props}
    >
      <path
        d="M0.115085 1.16012L1.14818 0.116792C1.30162 -0.0381746 1.55118 -0.0381746 1.70463 0.116792L5.72177 4.17375C5.87522 4.32871 6.12478 4.32871 6.27823 4.17375L10.2954 0.116225C10.4488 -0.0387418 10.6984 -0.0387418 10.8518 0.116225L11.8849 1.15956C12.0384 1.31452 12.0384 1.56656 11.8849 1.72152L6.27823 7.38377C6.12478 7.53874 5.87522 7.53874 5.72177 7.38377L0.115085 1.72152C-0.0383616 1.56656 -0.0383616 1.31452 0.115085 1.15955L0.115085 1.16012Z"
        fill="currentColor"
      />
    </Icon>
  );
});
